import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';

/**
 * Redirect every navigation request /prodigy to report/prodigy.
 * Guard to redirect /prodigy/... To /report/prodigy.
 *
 * @param {ActivatedRouteSnapshot} route Route.
 * @param {RouterStateSnapshot} state RouterStateSnapshot.
 * @returns {boolean}
 */
export const redirectProdigyToReportRoutes = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  const nav = inject(NavController);
  nav.navigateForward(`/report/prodigy` + state.url.replace('/prodigy', ''));
  return false;
};
